import { z } from 'zod';

// Re-export the shared row schema used by this mutation's response
export { zodLedgerAccountSchema as zodDeleteLedgerAccountResponseSchema } from '../validations';

export const zodDeleteLedgerAccountEndpointSchema = z.tuple([
  z.literal('ledger_accounts'),
  z.uuid(),
]);
